import React, { useEffect, useState } from 'react'
import tayaraLogo from '../../../assets/images/tayara-logo.webp'
import logoNacer from '../../../assets/images/logo-nacer.webp'
import tayaraKpis from '../../../assets/images/tayarakpis.gif'
import tayaraTeam from '../../../assets/images/tayaraTeam.jpeg'
import chatRefactoring from '../../../assets/images/chatRefactoring.png'
import adInsertionFlow from '../../../assets/images/adInsertionFlow.png'
import homePage from '../../../assets/images/homePage.png'
import newFeatures from '../../../assets/images/newFeatures.PNG'
import offersPage from '../../../assets/images/offerandservices.png'
import navigationBar from '../../../assets/images/navigationBar.png'
import gamesAndEvents from '../../../assets/images/gamesAndEvents.PNG'
import ZoomableImage from '../../ZoomableImage'
import pinchtozoom from '../../../assets/images/pinchtozoom.png'
import getStartedImage from '../../../assets/images/getStartedImage.gif'
import tayaraExpo from '../../../assets/images/demoTayaraExpo.png'
import Footer from '../../Footer/Footer'
import { BiArrowBack } from 'react-icons/bi'

const Tayara = () => {
  const [loading, setLoading] = useState(true)
  const [showPopupTayaraProject, setShowTayaraProjectPopup] = useState(true)

  useEffect(() => {
    import('./projects.css')
      .then(() => setLoading(false)) // CSS is imported, stop loading
      .catch(() => setLoading(false)) // In case of error, stop loading as well
  }, [])

  function handleCloseOnboardingTayaraProject() {
    setShowTayaraProjectPopup(false)
  }

  return (
    <div>
      {showPopupTayaraProject && (
        <div
          class="showpopup"
          onClick={(e) => {
            if (e.target !== e.currentTarget) return
            handleCloseOnboardingTayaraProject()
          }}
        >
          <img
            src={pinchtozoom}
            alt="pinch to zoom project images"
            className="NavigationGuide"
          />
          <button onClick={() => handleCloseOnboardingTayaraProject()}>
            Skip
          </button>
        </div>
      )}
      {loading ? (
        <div class="spinner-wrap">
          <div className="loading-container">
            <img className="logo-on-loading" src={logoNacer} alt="" />
            <div class="spinner-item"></div>
            <div class="spinner-item spinner-item--2"></div>
          </div>
        </div>
      ) : (
        <>
          <div className="bg-black font-sans overflow-hidden">
            <header class="header">
              <a href="https://nacermediouni.vercel.app/">
                <img class="logo" src={logoNacer} alt="" />
              </a>
            </header>
            <div className="absolute flex flex-col z-[9999] top-11 right-6 md:right-12 w-fit h-fit">
              <a
                className=" flex gap-4 items-center text-sm font-bold  text-white hover:text-neutral-500 "
                href="https://nacer-mediouni.netlify.app/works"
              >
                <BiArrowBack size={20} />
                Back to projects
              </a>
              <span className="relative left-10 bottom-3 rotate-90 w-[1px] h-10 bg-[#00ffc6]"></span>
            </div>

            <div className="w-full h-screen bg-[url('/src/assets/images/featuringTayara.png')] bg-no-repeat bg-contain lg:bg-contain lg:bg-fixed  bg-center ">
              <div className="absolute inset-0 z-10 w-full h-screen bg-black/80 ">
                <div className="w-full h-full flex flex-col items-center justify-end gap-6 pb-[55%] md:pb-[15%]">
                  {/* <h1 className="text-6xl font-extrabold">Tayara</h1> */}
                  <img
                    src={tayaraLogo}
                    alt="tayara-project-logo"
                    className="w-1/2 lg:w-[20%]"
                  />

                  <p className="mx-4 lg:mx-[15%] text-base lg:text-xl text-center font-medium">
                    Tunisia's Premier Online Marketplace serving more than
                    1,000,000 users, connecting buyers and sellers for a range
                    of products and services.
                  </p>
                  <div className="w-full absolute bottom-10">
                    <div class="scd">
                      <div class="chv"></div>
                      <div class="chv"></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-slate-50 text-black ">
              <div className="w-full flex flex-col gap-4">
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Role</h1>
                  <span className="text-base">
                    Frontend Engineer & UX Designer
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Settings</h1>
                  <span className="text-base">
                    Team of 11, consisting of Fullstack Engineers, Graphic
                    designer, Mobile Developer, Cloud Engineer, Growth Hacker,
                    Team Lead, PO, CTO.
                  </span>
                </div>
                <div className="flex flex-col gap-2 text-neutral-600">
                  <h1 className="text-xl font-extrabold">Timeline</h1>
                  <span className="text-base">2021 - 2024</span>
                </div>
              </div>
            </div>
            <div className="w-full h-full py-10 px-[10%] md:px-[20%] bg-white text-neutral-600 ">
              <div className="w-full flex justify-between items-center flex-wrap gap-4">
                <div className="w-fit">
                  <h1 className="text-3xl md:text-5xl font-extrabold">
                    Tayara
                  </h1>
                  <h1 className="text-base md:text-xl font-extrabold my-2">
                    #1 Most visited Tunisian Classified Marketplace
                  </h1>
                </div>
                <a
                  href="https://www.tayara.tn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                >
                  View final product
                </a>
              </div>
              <img
                src={tayaraKpis}
                className="w-full my-10 rounded-3xl border-[1px] border-neutral-100"
                alt="tayara-project-kpis"
              />
              <p className="text-base md:text-lg  font-normal font-sans my-10">
                <a
                  href="https://www.tayara.tn/"
                  rel="noreferrer"
                  target="_blank"
                  className="underline underline-offset-2 hover:underline-offset-4"
                >
                  Tayara.tn
                </a>{' '}
                is an <b> online marketplace </b> serving over 1,000,000+ users
                in Tunisia, France, and Germany, that connects buyers and
                sellers for a range of products and services. Users can browse
                categories like real estate, vehicles, electronics, and more. It
                facilitates convenient transactions and fosters economic
                activity. It provides a platform for individuals and businesses
                to buy and sell within Tunisia's marketplace, promoting seamless
                online shopping experiences.
              </p>

              <div className="w-full justify-between items-center my-10 md:my-14">
                <h1 className="text-xl md:text-2xl font-extrabold my-4">
                  Role & Project
                </h1>
                <p className="text-base md:text-lg">
                  I worked as a full-time <b> UX/UI designer </b> and{' '}
                  <b> front-end developer </b> with a team of 3 developers and
                  other departments since October 2021. <br /> <br />
                  My mission was to blend creativity and technical expertise to
                  improve the platform's overall user experience and visual
                  appeal. My role included <b> design </b>, <b> code </b>, and
                  <b> maintenance </b> of their main platform, with at least 2
                  rounds of iteration based on customer feedback, analytics,
                  brand identity and business goals.
                </p>
                <img
                  src={tayaraTeam}
                  className="lg:w-[50%] mx-auto rounded-xl my-10"
                  alt="tayara-team"
                />
              </div>

              <div className="my-20">
                <h1 className="text-xl md:text-2xl font-extrabold my-4">
                  Design and Implementation of New Features <br />
                </h1>

                <p className="text-base md:text-lg ">
                  I was responsible for designing and implementing key new
                  features, including <b>Saved Search</b>,{' '}
                  <b>Seller Dashboard</b>, <b>Planned Ad Boost</b>, and{' '}
                  <b>Ad Statistics</b>. These features were designed to improve
                  user engagement and offer advanced options for ad management.
                </p>
                <img
                  src={newFeatures}
                  className="w-full my-10"
                  alt="tayara-project-new-features"
                />
              </div>

              <div className="my-10">
                <h1 className="text-xl md:text-2xl font-extrabold my-4">
                  Redesign & Development
                  <br />
                </h1>

                <div className="w-full">
                  <h1 className="text-lg md:text-xl font-extrabold my-6">
                    Navigation Header
                  </h1>

                  <p className="text-base md:text-lg ">
                    I was responsible for improving the navigation header to
                    ensure consistency and usability across multiple devices. By
                    optimizing the layout and refining the responsive design
                    using Figma (Wireframing and Prototyping), Tailwind CSS and
                    Next.js (Development), I enhanced the user experience,
                    making navigation smoother on mobile, tablet, and desktop.
                  </p>

                  <img
                    src={navigationBar}
                    className="w-full my-10"
                    alt="tayara-project-navigation-header"
                  />
                </div>

                <div className="w-full">
                  <h1 className="text-lg md:text-xl font-extrabold my-6">
                    Home Page
                  </h1>
                  <p className="text-base md:text-lg ">
                    Leading the redesign and implementation of the home page, I
                    focused on enhancing the user journey from the moment they
                    landed on the site. I worked closely with the Product and
                    Sales teams to ensure the redesign addressed customer needs
                    while aligning with business goals. Together, we developed a
                    user-friendly and responsive layout that made Tayara’s
                    products more accessible to a wider audience. I prioritized
                    faster load times, improved accessibility, and increased
                    user interaction, contributing to a significant improvement
                    in user engagement metrics.
                  </p>
                  <img
                    src={homePage}
                    className="w-full my-10
              "
                    alt="tayara-project-home-page"
                  />
                </div>

                <div className="w-full">
                  <h1 className="text-lg md:text-xl font-extrabold my-6">
                    Ad Insertion Flow and Chat System Refactoring
                  </h1>
                  <p className="text-base md:text-lg ">
                    I took on the challenge of refactoring the existing ad
                    insertion flow and chat system. The goal was to streamline
                    the user experience and improve system performance. I
                    carefully analyzed the user journey, optimized the process
                    for inserting ads, and enhanced the chat system to support
                    real-time communication with minimal latency. By refactoring
                    the codebase, I ensured greater scalability and
                    maintainability, ultimately improving both the user
                    experience and the system's performance.
                  </p>
                  <ZoomableImage src={chatRefactoring} />
                  <ZoomableImage src={adInsertionFlow} />
                </div>

                <div className="w-full">
                  <h1 className="text-lg md:text-xl font-extrabold my-6">
                    Offer and Services Page
                  </h1>

                  <p className="text-base md:text-lg ">
                    I designed and developed the{' '}
                    <a
                      href="https://www.tayara.tn/services/"
                      rel="noreferrer"
                      target="_blank"
                      className="underline underline-offset-2 hover:underline-offset-4"
                    >
                      Offer and Services page{' '}
                    </a>{' '}
                    from scratch, ensuring a user-friendly interface that
                    highlighted key offerings. I worked closely with
                    stakeholders to understand the business needs and crafted an
                    intuitive layout that effectively communicated the value of
                    each service.
                  </p>

                  <img
                    src={offersPage}
                    className="w-full my-10
              "
                    alt="tayara-project-kpis"
                  />
                </div>

                <div className="w-full">
                  <h1 className="text-lg md:text-xl font-extrabold my-6">
                    Event Covers and Games
                  </h1>

                  <p className="text-base md:text-lg ">
                    I designed and developed event covers and games in
                    collaboration with the marketing and events teams, ensuring
                    that the visuals aligned with the brand identity and
                    supported key promotional goals. This teamwork helped create
                    a cohesive experience and reinforced the campaign's
                    objectives.
                  </p>
                  <img
                    src={gamesAndEvents}
                    className="w-full my-10
              "
                    alt="tayara-project-kpis"
                  />
                </div>

                <div className="w-full">
                  <h1 className="text-lg md:text-xl font-extrabold my-6">
                    Le Show de l'automobile
                  </h1>

                  <p className="text-base md:text-lg ">
                    I led the design and development of the official website for
                    the first edition of the Second-Hand Car Show. The site was
                    crafted with a user-centered approach, offering a clear and
                    engaging interface for exploring event details. I focused on
                    creating a responsive and dynamic design that catered to
                    both exhibitors and visitors, ensuring a smooth user
                    experience across all devices.
                  </p>
                  <div className="w-full my-10 p-10 bg-[#090903] flex mx-auto justify-center items-center">
                    <img
                      src={tayaraExpo}
                      className="w-[94%] border-[1px] border-white/10 rounded-3xl 
              "
                      alt="tayara-project-kpis"
                    />
                  </div>
                  <div className="w-full text-center mx-auto mt-20 mb-10">
                    <a
                      href="https://le-show-de-lautomobile.vercel.app/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                    >
                      View preview
                    </a>
                  </div>
                </div>

                <div className="my-20">
                  <h1 className="text-xl md:text-2xl font-extrabold my-4">
                    Key Achievements at Tayara <br />
                  </h1>

                  <ul className="list-disc my-4 text-base md:text-lg">
                    <li className="my-4">
                      <strong>
                        ● Redesigned and developed key sections of the platform
                        for a more consistent user experience,
                      </strong>{' '}
                      resulting in a significant decrease in mobile bounce
                      rates, page load times, and an increase in user
                      satisfaction.
                    </li>
                    <li className="my-4">
                      <strong>
                        ● Developed user-focused features like Saved Search and
                        Seller Dashboard,
                      </strong>{' '}
                      increasing ad visibility and improving seller engagement.
                    </li>
                    <li className="my-4">
                      <strong>
                        ● Optimized the ad insertion process and the chat
                        system,
                      </strong>{' '}
                      enhancing communication efficiency and reducing ad
                      insertion time by 30%.
                    </li>
                    <li className="my-4">
                      <strong>● Created the Offer and Services page,</strong>{' '}
                      boosting engagement and improving customer understanding
                      of services.
                    </li>
                    <li className="my-4">
                      <strong>
                        ● Developed a user-friendly seller dashboard that
                      </strong>{' '}
                      increased seller retention and significantly enhanced
                      overall seller satisfaction.
                    </li>
                    <li className="my-4">
                      <strong>
                        ● Improved the navigation header across devices,
                      </strong>{' '}
                      resulting in increased user engagement and satisfaction.
                    </li>
                    <li className="my-4">
                      <strong>
                        ● Designed and integrated dynamic event covers and
                        interactive games,
                      </strong>{' '}
                      leading to an increase in conversion rates and overall
                      platform engagement.
                    </li>
                    <li className="my-4">
                      <strong>
                        ● Led the design and launch of the second-hand car show
                        website,
                      </strong>{' '}
                      increasing event awareness and registrations.
                    </li>
                  </ul>
                </div>
              </div>
              <div className="w-full h-full my-10">
                <iframe
                  className="w-full h-[26rem] rounded-3xl "
                  src="https://www.youtube.com/embed/KjMbkoPKvQ4?si=fLRh3MIALoLcY5nL"
                  title="YouTube video player"
                  frameborder="0"
                  allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                  referrerpolicy="strict-origin-when-cross-origin"
                  allowfullscreen
                ></iframe>
              </div>
              <div className="w-full text-center mx-auto mt-20 mb-10">
                <a
                  href="https://www.tayara.tn/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className=" p-4 text-sm lg:text-base text-white font-medium bg-neutral-800 hover:bg-transparent hover:text-neutral-800 border-2 border-neutral-800"
                >
                  View final product
                </a>
              </div>

              <div className="w-full text-center mx-auto my-10">
                <a
                  href="/works"
                  rel="noopener noreferrer"
                  className=" text-sm lg:text-base text-neutral-800 font-medium underline"
                >
                  Back to projects
                </a>
              </div>
            </div>
            <div className=" bg-black flex flex-col md:flex-row justify-start items-center ">
              <img
                src={getStartedImage}
                alt="get started"
                className="w-[50%]"
              />
              <div className="w-full h-full gap-10 flex flex-col justify-center items-center md:items-start mx-auto pb-20 md:pb-0">
                <p className="text-3xl lg:text-5xl md:w-[90%] px-[10%] md:px-0 text-center md:text-start font-semibold">
                  Want to build remarkable products together?
                </p>
                <a
                  href="https://www.linkedin.com/in/nacermediouni/"
                  aria-label="Linkedin"
                  target="_blank"
                  rel="noreferrer"
                  className=" text-2xl lg:text-3xl text-[#00ffc6] font-bold underline underline-offset-2 hover:underline-offset-1"
                >
                  Let's get strated!
                </a>
              </div>
            </div>

            <div className="  w-full flex flex-col justify-center items-center pt-20 pb-8 px-[10%] md:px-[20%] font-sans bg-white">
              <Footer />
            </div>
          </div>
        </>
      )}
    </div>
  )
}

export default Tayara
